import { History } from "history";

export function setupParentUrlSync(history: History) {
  // check if iframe
  if (window.top === window.self) return;

  const sendUrlToParent = (pathname: string, search: string) => {
    const url = window.location.origin + pathname + search;

    window.parent.postMessage({ type: "IFRAME_URL_CHANGED", url }, "*");
  };
  // listen for router changes
  history.listen((location) => {
    sendUrlToParent(location.pathname, location.search);
  });
}
